import React from "react";

const About = () => {
  return (
    <section className="about_sec">
      <main className="about_sec__intro">
        <h1>
          <span className="color-pink">"</span> Everything Start With a Passion
          for Technologies <span className="color-pink">"</span>
        </h1>
        <p>
          I’m... A frontend developer, responsible for designing and creating
          engaging user experiences for web and mobile applications. With a
          strong understanding of HTML, CSS, and JavaScript, as well as
          experience in frontend frameworks such as <b>React</b>, <b>Next</b>{" "}
          and <b>Vue.js</b>.
          <br /> <br />
          My ability to translate complex design concepts into{" "}
          <b>user-friendly</b>, responsive interfaces is highly valued by my
          clients and coworkers. I have a <b>strong eye</b> for detail, a
          passion for creating aesthetically pleasing designs, and a{" "}
          <b>commitment</b> to building applications that are both functional
          and visually appealing.
          <br /> <br />
          My collaboration with designers, developers, and{" "}
          <b>project managers</b> helps me ensure that the end product not only
          meets the desired aesthetics but also provides a seamless{" "}
          <b>user experience</b>. My commitment to staying up-to-date with the{" "}
          <b>latest industry</b> trends and technologies keeps me at the
          forefront of my field.
        </p>
      </main>
      <div className="about_sec__heightlights">
        <div className="about_sec__heightlights__item">
          <span className="about_sec__heightlights__item__title">4+ year</span>
          <span className="about_sec__heightlights__item__desc">
            Experience
          </span>
        </div>
        <div className="about_sec__heightlights__item">
          <span className="about_sec__heightlights__item__title">20+</span>
          <span className="about_sec__heightlights__item__desc">Projects</span>
        </div>
        <div className="about_sec__heightlights__item">
          <span className="about_sec__heightlights__item__title">Good</span>
          <span className="about_sec__heightlights__item__desc">
            Product Sense
          </span>
        </div>
      </div>
      <div className="about_sec__experience">
        <h2>Experience:</h2>
        <div className="about_sec__experience__item">
          <h4>Software Engineer</h4>
          <h5>
            Deutsche Telekom <span>(Sept 2022 - current)</span>
          </h5>

          <p>
            utilising cutting-edge technology to resolve telecom challenges,
            creating new features, repairing bugs, and more...
          </p>
        </div>
        <div className="about_sec__experience__item">
          <h4>Senior Associate developer</h4>
          <h5>
            Infosys <span>(Oct 2021 - Aug 2022)</span>
          </h5>

          <p>
            Lead a group of front-end developers, identify solutions to issues
            that arise during development, respond to their questions, fix
            vulnerabilities, upgrade versions of React, and more...
          </p>
        </div>
        <div className="about_sec__experience__item">
          <h4>Frontend developer</h4>
          <h5>
            Startxlabs <span>(Oct 2019 - Sept 2021)</span>
          </h5>
          <span></span>
          <p>
            Developed 360-degree solutions for multiple projects, managed design
            teams, designed the front ends of various applications using React
            and React Native, and more...
          </p>
        </div>
        <div className="about_sec__experience__item">
          <h4>UI Designer and Web developer</h4>
          <h5>
            King Digital PVT <span>(Aug 2018 - Sept 2019)</span>
          </h5>
          <p>
            Complete design and development for a number of websites,
            performance optimization, addition of SEO tags, animations,
            customised features, etc...
          </p>
        </div>
      </div>
      <div className="about_sec__education">
        <h2>Education:</h2>
        <div className="about_sec__education__item">
          <h4>Rajiv Gandhi Prodyogiki Vishwavidyalaya</h4>
          <h5>Bachelor of Engineering in Computer Science</h5>
          <p>2013-2017</p>
        </div>
        <div className="about_sec__education__item">
          <h4>Jawahar Navodaya Vidyalaya </h4>
          <h5>
            Schooling (6<sup>th</sup> - 12<sup>th</sup>)
          </h5>
          <p>
            Completed 12<sup>th</sup> with computer science.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
